import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Challenge from "../../components/Challenge";
import ContactSection from "../../components/ContactSection";
import Ecosystem from "../../components/Ecosystem";
import Hero from "../../components/Hero";
import Nav from "../../components/navComponents/Nav";
import Partners from "../../components/Partners";
import Products from "../../components/Products";
import Solution from "../../components/Solution";
import Values from "../../components/Values";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      handleScrollToSection(location.hash);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  const handleScrollToSection = (hash) => {
    document.querySelector(hash)?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <Box>
      <Nav />

      <Hero />

      {/* <Partners /> */}

      <Challenge />

      <Solution />

      <Values />

      <Ecosystem />

      <Products />

      <ContactSection />
    </Box>
  );
};

export default HomePage;
